import * as React from 'react'
import { ExternalCreditData, getPaymentsColumns, getPaymentScheduleColumns, getProductsColumns }
    from '../../../../Model/ExternalData'
import LocalizationStore from '../../../../Stores/LocalizationStore'
import { inject } from 'mobx-react'
import { NavLink } from 'react-router-dom'
import DateTimeHelper from '../../../../Helpers/DateTimeHelper'
import { toJS } from 'mobx'
import ReactTable from 'react-table'
import * as c from 'classnames'

export interface IExternalDataDetailsViewProps {
    externalCreditData: ExternalCreditData
    localizationStore?: LocalizationStore
    className?: string
}

@inject('localizationStore')
export default class ExternalDataDetailsView extends React.Component<IExternalDataDetailsViewProps> {
    render() {
        const { externalCreditData, localizationStore, className } = this.props

        const products = externalCreditData.products
            ? toJS(externalCreditData.products)
            : []

        let payments = externalCreditData.payments
            ? externalCreditData.payments.map(function (p: any) {
                p['paymentDate'] = DateTimeHelper.formatDateForList(p['paymentDate'])

                return p
            })
            : []
        payments = toJS(payments)

        let paymentSchedule = externalCreditData.paymentSchedule
            ? externalCreditData.paymentSchedule.map(function (p: any) {
                p['ddate'] = DateTimeHelper.formatDateForList(p['ddate'])

                return p
            })
            : []
        paymentSchedule = toJS(paymentSchedule)

        let declineReasonId = ''
        if (externalCreditData.declineReason) {
            const re = /\d+/g
            let matches = externalCreditData.declineReason.match(re)
            declineReasonId = matches ? matches[0] : ''
        }

        return (
            <div className={c('externalDataCreditInfoItem', className!)}>
                <div className="rt-td">
                    <label>{localizationStore!.t('creditNumber')}</label>:&nbsp;
                    <span>{externalCreditData.creditNumber}</span>
                </div>
                <div className="rt-td">
                    <label>{localizationStore!.t('creditDuration')}</label>:&nbsp;
                    <span>{externalCreditData.creditDuration}</span>
                </div>
                <div className="rt-td">
                    <label>{localizationStore!.t('status')}</label>:&nbsp;
                    <span>{externalCreditData.creditStatus}</span>
                </div>
                <div className="rt-td">
                    <label>{localizationStore!.t('totalSum')}</label>:&nbsp;
                    <span>{externalCreditData.creditAmount}</span>
                </div>
                <div className="rt-td">
                    <label>{localizationStore!.t('totalDpd')}</label>:&nbsp;
                    <span>{externalCreditData.totalDpd}</span>
                </div>
                <div className="rt-td">
                    <label>{localizationStore!.t('affiliate')}</label>:&nbsp;
                    <span>{externalCreditData.affiliate} ({externalCreditData.affiliateId})</span>
                </div>
                <div
                    className="rt-td"
                    hidden={
                        !(
                            externalCreditData.phoneComment
                            && externalCreditData.phoneComment.toString().length
                        )}
                >
                    <label>{localizationStore!.t('phoneComment')}</label>:&nbsp;
                <p className="phoneComment">{externalCreditData.phoneComment}</p>
                </div>
                <div className="rt-td">
                    <label>{localizationStore!.t('declineReason')}</label>:
                    &nbsp;
                <span>
                        {externalCreditData.declineReason}&nbsp;
                        <NavLink
                            className="contract-link"
                            to={'/externalData/searchByCreditNumber/' + declineReasonId}
                            target="_blank"
                        >
                            {declineReasonId}
                        </NavLink>
                    </span>
                </div>
                <div className="rt-td">
                    <label>{localizationStore!.t('prepaymentSum')}</label>:&nbsp;
                <span>{externalCreditData.prepaymentSum}</span>
                </div>

                <div className="rt-td">
                    <label>{localizationStore!.t('affiliate')}</label>:&nbsp;
                    {
                        externalCreditData.affiliateId ?
                            <span>
                                {externalCreditData.affiliate}
                                ({localizationStore!.t('id')} {externalCreditData.affiliateId})
                            </span> :
                            <span>{localizationStore!.t('no data')}</span>
                    }
                </div>

                <div className="rt-td">
                    <label>{localizationStore!.t('staffMember')}</label>:&nbsp;
                {
                        externalCreditData.staffMemberId ?
                            <span>
                                {externalCreditData.staffMember}
                                ({localizationStore!.t('id')} {externalCreditData.staffMemberId})
                        </span> :
                            <span>{localizationStore!.t('no data')}</span>
                    }
                </div>

                <div className="rt-td">
                    <label>{localizationStore!.t('dateCreateCredit')}</label>:&nbsp;
                {
                        externalCreditData.date ?
                            <span>{externalCreditData.date}</span> :
                            <span>{localizationStore!.t('no data')}</span>
                    }
                </div>

                <div className="rt-td">
                    <label>{localizationStore!.t('source')}</label>:&nbsp;
                {
                        externalCreditData.source ?
                            <span>{externalCreditData.source}</span> :
                            <span>{localizationStore!.t('no data')}</span>
                    }
                </div>

                <div className="rt-td">
                    <label>{localizationStore!.t('clientInfo')}</label>
                </div>

                <div className="rt-td">
                    <label>{localizationStore!.t('registrationAddress')}</label>:&nbsp;
                {
                        externalCreditData.client.registrationAddress ?
                            <span>{externalCreditData.client.registrationAddress}</span> :
                            <span>{localizationStore!.t('no data')}</span>
                    }
                </div>

                <div className="rt-td">
                    <label>{localizationStore!.t('lastName')}</label>:&nbsp;
                {
                        externalCreditData.client.lastName ?
                            <span>{externalCreditData.client.lastName}</span> :
                            <span>{localizationStore!.t('no data')}</span>
                    }
                </div>

                <div className="rt-td">
                    <label>{localizationStore!.t('middleName')}</label>:&nbsp;
                {
                        externalCreditData.client.middleName ?
                            <span>{externalCreditData.client.middleName}</span> :
                            <span>{localizationStore!.t('no data')}</span>
                    }
                </div>

                <div className="rt-td">
                    <label>{localizationStore!.t('firstName')}</label>:&nbsp;
                {
                        externalCreditData.client.firstName ?
                            <span>{externalCreditData.client.firstName}</span> :
                            <span>{localizationStore!.t('no data')}</span>
                    }
                </div>

                <div className="rt-td">
                    <label>{localizationStore!.t('actualAddress')}</label>:&nbsp;
                {
                        externalCreditData.client.actualAddress ?
                            <span>{externalCreditData.client.actualAddress}</span> :
                            <span>{localizationStore!.t('no data')}</span>
                    }
                </div>

                <div className="rt-td white-space-normal">
                    <label>{localizationStore!.t('phones')}</label>:&nbsp;

                {
                        externalCreditData.client.mobilePhone ?
                            <span>
                                {externalCreditData.client.mobilePhone} ({localizationStore!.t('MobilePhone')})
                            </span> :
                            ''
                    }
                    &nbsp;
                {
                        externalCreditData.client.homePhone ?
                            <span>{externalCreditData.client.homePhone} ({localizationStore!.t('HomePhone')})</span> :
                            ''
                    }
                    &nbsp;
                {
                        externalCreditData.client.workPhone ?
                            <span>{externalCreditData.client.workPhone} ({localizationStore!.t('WorkPhone')})</span> :
                            ''
                    }
                    &nbsp;
                {
                        externalCreditData.client.otherPhone ?
                            <span>{externalCreditData.client.otherPhone} ({localizationStore!.t('OtherPhone')})</span> :
                            ''
                    }
                </div>

                <div className="rt-td">
                    <label>{localizationStore!.t('income')}</label>:&nbsp;
                {
                        externalCreditData.client.income ?
                            <span>{externalCreditData.client.income}</span> :
                            <span>{localizationStore!.t('no data')}</span>
                    }
                </div>

                {/* <div className="rt-td">
                    <label>{localizationStore!.t('clientStatus')}</label>:&nbsp;
                {
                        externalCreditData.client.rStatus ?
                            <span>{externalCreditData.client.rStatus}</span> :
                            <span>{localizationStore!.t('no data')}</span>
                    }
                </div>

                <div className="rt-td">
                    <label>{localizationStore!.t('clientCode')}</label>:&nbsp;
                {
                        externalCreditData.client.clientCode ?
                            <span>{externalCreditData.client.clientCode}</span> :
                            <span>{localizationStore!.t('no data')}</span>
                    }
                </div>

                <div className="rt-td">
                    <label>{localizationStore!.t('standartAccountNumber')}</label>:&nbsp;
                {
                        externalCreditData.client.standartAccountNumber ?
                            <span>{externalCreditData.client.standartAccountNumber}</span> :
                            <span>{localizationStore!.t('no data')}</span>
                    }
                </div> */}

                <div className="rt-td">
                    <label>{localizationStore!.t('birthday')}</label>:&nbsp;
                {
                        externalCreditData.client.birthday ?
                            <span>{externalCreditData.client.birthday}</span> :
                            <span>{localizationStore!.t('no data')}</span>
                    }
                </div>

                {/* <div className="rt-td">
                    <label>{localizationStore!.t('cardno')}</label>:&nbsp;
                {
                        externalCreditData.client.cardno ?
                            <span>{externalCreditData.client.cardno}</span> :
                            <span>{localizationStore!.t('no data')}</span>
                    }
                </div> */}

                <div className="productsInfo rt-td">
                    <p>{localizationStore!!.t('productsInfo')}</p>
                    <ReactTable
                        key={'productsId' + Math.random()}
                        data={products}
                        columns={getProductsColumns()}
                        className="-striped -highlight"
                        noDataText={localizationStore!.t('No data text')}
                        defaultPageSize={3}
                        previousText={localizationStore!.t('Previous')}
                        nextText={localizationStore!.t('Next')}
                        pageText={localizationStore!.t('Page')}
                        ofText={localizationStore!.t('of')}
                    // defaultExpanded
                    />
                </div>

                <div className="paymentsSchedule rt-td">
                    <p>{localizationStore!.t('paymentsScheduleJson')}</p>
                    <ReactTable
                        key={'paymentsSchedule' + Math.random()}
                        data={paymentSchedule}
                        columns={getPaymentScheduleColumns()}
                        className="-striped -highlight"
                        noDataText={localizationStore!.t('No data text')}
                        defaultPageSize={12}
                        previousText={localizationStore!.t('Previous')}
                        nextText={localizationStore!.t('Next')}
                        pageText={localizationStore!.t('Page')}
                        ofText={localizationStore!.t('of')}
                    // defaultExpanded
                    />
                </div>

                <div className="paymentsInfo rt-td">
                    <p>{localizationStore!.t('paymentsInfo')}</p>
                    <ReactTable
                        key={'paymentsInfo' + Math.random()}
                        data={payments}
                        columns={getPaymentsColumns()}
                        className="-striped -highlight"
                        noDataText={localizationStore!.t('No data text')}
                        defaultPageSize={12}
                        previousText={localizationStore!.t('Previous')}
                        nextText={localizationStore!.t('Next')}
                        pageText={localizationStore!.t('Page')}
                        ofText={localizationStore!.t('of')}
                    // defaultExpanded
                    />
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/ExternalData/ExternalDataViews/ExternalDataDetailsView.tsx